import { PrivacyPolicy } from "../../../jsx/components/Dashboard/PrivacyPolicy";

const HomeWrapper = () => {
  return <PrivacyPolicy />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.customer];
export default constore(HomeWrapper);
